module.exports = __webpack_public_path__ + "43952327cdc1ae3bf670d42b3fc4be13.png";